module.exports = __webpack_public_path__ + "img/flavor8.e703c13e.png";